export const GET_INVITE_LIST_REQUEST = 'GET_INVITE_LIST_REQUEST'
export const GET_INVITE_LIST_FAIL = 'GET_INVITE_LIST_FAIL'
export const GET_INVITE_LIST_SUCCESS = 'GET_INVITE_LIST_SUCCESS'

export const ADD_INVITE_LIST_REQUEST = 'ADD_INVITE_LIST_REQUEST'
export const ADD_INVITE_LIST_FAIL = 'ADD_INVITE_LIST_FAIL'
export const ADD_INVITE_LIST_SUCCESS = 'ADD_INVITE_LIST_SUCCESS'

export const RENEW_INVITE_LIST_REQUEST = 'RENEW_INVITE_LIST_REQUEST'
export const RENEW_INVITE_LIST_FAIL = 'RENEW_INVITE_LIST_FAIL'
export const RENEW_INVITE_LIST_SUCCESS = 'RENEW_INVITE_LIST_SUCCESS'

export const DELETE_INVITE_LIST_REQUEST = 'DELETE_INVITE_LIST_REQUEST'
export const DELETE_INVITE_LIST_FAIL = 'DELETE_INVITE_LIST_FAIL'
export const DELETE_INVITE_LIST_SUCCESS = 'DELETE_INVITE_LIST_SUCCESS'

export const INVITE_LIST_SET_PAGINATION = 'INVITE_LIST_SET_PAGINATION'
